// nls-rework\src\app\components\loan\loan-summary\loan-summary.component.ts
import { Component, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PaymentHistoryComponent } from "../payment-history/payment-history.component";
import { AutoPayStatusComponent } from "../auto-pay-status/auto-pay-status.component";
import { switchMap } from 'rxjs';
import { LoanService } from '../../../services/loan.service';
import { LoanDetail, LoanGeneralStatusCode  } from '../../../models/loan.model';
import { UpcomingPaymentsComponent } from '../upcoming-payments/upcoming-payments.component';

/**
 * Component that displays a summary of loan information including:
 * - Due date and amount
 * - Auto Pay status and controls
 * - Payment history
 * - Link to detailed loan information
 */
@Component({
  selector: 'app-loan-summary',
  templateUrl: './loan-summary.component.html',
  styleUrl: './loan-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PaymentHistoryComponent,
    AutoPayStatusComponent,
    MatCardModule,
    MatButtonModule,
    DatePipe,
    CurrencyPipe,
    RouterModule,
    UpcomingPaymentsComponent,

  ]
})
export class LoanSummaryComponent {
  /** Service to handle all loan-related operations */
  readonly #loanService = inject(LoanService);

  /** The ID of the loan to display */
  readonly id = input.required<string>();
  readonly LoanGeneralStatusCode = LoanGeneralStatusCode;
  /** Observable of the loan ID to react to changes */
  readonly #id$ = toObservable(this.id);
  readonly refreshTick = signal(0); // bump this to notify children

    onPaymentsChanged() {
    this.refreshTick.update(n => n + 1);
  }

  /** Signal containing the loan details */
  readonly loan = toSignal<LoanDetail | null>(
    this.#id$.pipe(
      switchMap(id => this.#loanService.getLoanDetails(id))
    ), { initialValue: null }
  );
}
